import React from "react";


export default function AuthRoomCallLoading() {
    return (
        <div style={{height:"100vh", width:"100vw", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <h1 className="mx-auto">Loading</h1>
        </div>
    );
}